module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sidekick/save-msg-as-template-btn.svg"